import { useState } from 'react';
import { Typography, TextField, Button, Stack, Tabs, Tab, Box } from '@mui/material';
import { analiseVisual, gerarChecklist } from '../services/api';

const IaPage = () => {
  const [tab, setTab] = useState(0);
  const [pergunta, setPergunta] = useState('');
  const [imagem, setImagem] = useState(null);
  const [resposta, setResposta] = useState('');
  const [descricao, setDescricao] = useState('');
  const [checklist, setChecklist] = useState('');

  const handleAnalise = async () => {
    const form = new FormData();
    if (imagem) form.append('imagem', imagem);
    form.append('pergunta', pergunta);
    const r = await analiseVisual(form);
    setResposta(r.resposta || '');
  };

  const handleGerar = async () => {
    const r = await gerarChecklist({ descricao });
    setChecklist(r.checklist || '');
  };

  return (
    <div>
      <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ mb: 2 }}>
        <Tab label="Inspeção Visual" />
        <Tab label="Gerador de Checklist" />
      </Tabs>
      {tab === 0 && (
        <Box>
          <Stack spacing={2} maxWidth={400}>
            <input type="file" onChange={e => setImagem(e.target.files[0])} />
            <TextField label="Pergunta" value={pergunta} onChange={e => setPergunta(e.target.value)} />
            <Button variant="contained" onClick={handleAnalise}>Analisar com IA</Button>
            <Typography>{resposta}</Typography>
          </Stack>
        </Box>
      )}
      {tab === 1 && (
        <Box>
          <Stack spacing={2} maxWidth={500}>
            <TextField label="Descreva o processo" multiline rows={4} value={descricao} onChange={e => setDescricao(e.target.value)} />
            <Button variant="contained" onClick={handleGerar}>Gerar com IA</Button>
            <Typography component="pre" whiteSpace="pre-wrap">{checklist}</Typography>
          </Stack>
        </Box>
      )}
    </div>
  );
};

export default IaPage;
